export default [{
	titulo: 'Pregão Online',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/pregao-online',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Editar'
	}]
}]